import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { FileUploadService }   from './file-upload.service';

export const Ng1FileUploadModule = angular
  .module('control-room.shared.services.fileUploadService', [])
  .factory('crFileUploadService', downgradeInjectable(FileUploadService));
